<template>
    <div>
        <div class="card max-w-md mx-auto">
            <div class="flex justify-between items-center">
                <span class="font-semibold">
                    {{ selectedAddresses.length }}/{{ addresses.length }} adresser markerade
                </span>
                <button
                    class="btn btn-md btn-md is-primary md:min-w-lg"
                    type="submit"
                >
                    Spara adresser
                </button>
            </div>
            <p class="mt-xl mb-0">
                Nedan listas alla osignerade adresser som finns i säljprojektet. Markera de adresser som ska ingå i säljomgången.<br>
                Signerade adresser listas inte i denna vy och kan inte läggas till eller tas bort ur säljomgången.
            </p>
        </div>
        <div class="card max-w-md mx-auto">
            <h4 class="card__title">
                <checkbox-input
                    v-model="selectAll"
                    @toggle="toggleAll"
                >
                    <span class="font-semibold">Osignerade adresser</span>
                </checkbox-input>
            </h4>

            <div class="w-full rounded bg-neutral-lightest p-sm mb-sm flex">
                <div class="column w-1/2">
                    <div class="form-input-with-icon relative">
                        <input
                            v-model="query"
                            type="text"
                            class="form-input"
                            style="height: 40px; font-size:14px;"
                            placeholder="Filtrera på adress"
                        >
                        <font-awesome-icon icon="search" class="text-xs" />
                    </div>
                </div>
                <div class="column w-1/2">
                    <div class="select">
                        <select
                            v-model="deliveryProjectId"
                            style="height: 40px;"
                            required
                            class="form-input p-md text-xs"
                        >
                            <option :value="0">Alla leveransprojekt</option>
                            <option
                                v-for="(id, name) in deliveryProjects"
                                :value="id"
                            >
                                {{ name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="overflow-auto">
                <table class="table">
                    <tbody>
                        <sales-period-unsigned-address
                            v-for="address in filteredAddresses"
                            :key="address.id"
                            :address="address"
                            :selected-addresses="selectedAddresses"
                            :toggle-address="toggleAddress"
                        />
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import SalesPeriodUnsignedAddress from './SalesPeriodUnsignedAddress';
    export default {
        components: {
            SalesPeriodUnsignedAddress,
        },
        props: {
            salesProject: {
                required: true,
                type: Object,
            },
            salesPeriod: {
                required: true,
                type: Object,
            },
            addresses: {
                type: Array,
                required: true,
            },
            preSelectedAddresses: {
                type: Array,
                default: () => [],
            },
            deliveryProjects: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                filteredAddresses: [],
                selectedAddresses: [],
                selectAll: false,
                query: '',
                deliveryProjectId: 0,
            };
        },
        watch: {
            query() {
                this.searchAddresses();
                if (this.deliveryProjectId) {
                    this.filterByDeliveryProject();
                }
            },
            deliveryProjectId() {
                if (! this.deliveryProjectId) {
                    this.searchAddresses();

                    return;
                }

                this.searchAddresses();
                this.filterByDeliveryProject();
            },
        },
        mounted() {
            if (this.preSelectedAddresses.length) {
                this.selectedAddresses = this.preSelectedAddresses.map((addressId) => addressId);
            }

            this.filteredAddresses = this.addresses;
        },
        methods: {
            searchAddresses() {
                const query = this.query;
                if (! query) {
                    this.filteredAddresses = this.addresses;

                    return;
                }

                this.filteredAddresses = this.addresses
                    .filter((address) => address.full_address_with_apartment_number.toLowerCase().match(query));
            },
            filterByDeliveryProject() {
                this.filteredAddresses = this.filteredAddresses
                    .filter((address) => address.delivery_project_id === this.deliveryProjectId);
            },
            toggleAll() {
                this.selectedAddresses = [];

                if (this.selectAll) {
                    this.selectedAddresses = this.addresses.map((address) => address.id);
                }
            },
            toggleAddress(address) {
                const index = this.selectedAddresses.indexOf(address.id);
                if (this.selectedAddresses.indexOf(address.id) === -1) {
                    this.selectedAddresses.push(address.id);
                } else {
                    this.selectedAddresses.splice(index, 1);
                }
            },
        },
    };
</script>
